import React from "react";
import { Icon } from "@iconify/react";
import { formatNumber } from "../../utils/dashboardFormat";

const AnalyticCard = ({ data = {} }) => {
    const summary = data.summary || {};
    const instances = summary.instances || {};
    const contacts = summary.contacts || {};
    const campaigns = summary.campaigns || {};
    const templates = summary.templates || {};

    const instanceTotal = instances.total ?? data.activeInstances ?? 0;
    const instanceOnline = instances.connected ?? 0;
    const contactsUsed = contacts.used ?? data.totalUsedContacts ?? 0;
    const contactsRemaining = contacts.remaining;
    const contactsLimit = contacts.limit;
    const campaignTotal = campaigns.total ?? data.totalCampaign ?? 0;
    const templatesUsed = templates.used ?? data.totalUsedTemplates ?? 0;

    const cards = [
        {
            key: "instances",
            label: "Instances",
            value: instanceTotal,
            gradient: "bg-gradient-start-1",
            iconBg: "bg-success-main",
            icon: "logos:whatsapp-icon",
            badge: `${formatNumber(instanceOnline)} online`,
            sub: instances.allowed != null ? `${formatNumber(instances.allowed)} allowed` : null,
        },
        {
            key: "contacts",
            label: "Contacts",
            value: contactsUsed,
            gradient: "bg-gradient-start-2",
            iconBg: "bg-info",
            icon: "mdi:account-multiple-outline",
            sub:
                contactsLimit > 0
                    ? `${formatNumber(contactsRemaining ?? 0)} left of ${formatNumber(contactsLimit)}`
                    : null,
        },
        {
            key: "campaigns",
            label: "Campaigns",
            value: campaignTotal,
            gradient: "bg-gradient-start-3",
            iconBg: "bg-warning-main",
            icon: "mdi-bullhorn",
            sub: `✓ ${formatNumber(campaigns.completed ?? 0)} · ⏳ ${formatNumber(
                campaigns.queue ?? 0
            )} · ✕ ${formatNumber(campaigns.failed ?? 0)}`,
        },
        {
            key: "templates",
            label: "Templates",
            value: templatesUsed,
            gradient: "bg-gradient-start-4",
            iconBg: "bg-secondary",
            icon: "mdi:file-document-outline",
            sub:
                templates.limit != null
                    ? `of ${formatNumber(templates.limit)} limit`
                    : null,
        },
    ];

    return (
        <div className="row row-cols-xxxl-4 row-cols-lg-4 row-cols-md-2 row-cols-sm-2 row-cols-1 gy-4">
            {cards.map((card) => (
                <div className="col" key={card.key}>
                    <div className={`card shadow-none border ${card.gradient} h-100`}>
                        <div className="card-body p-20">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                <div>
                                    <p className="fw-medium text-primary-light mb-1">{card.label}</p>
                                    <h6 className="mb-0 fs-4">{formatNumber(card.value)}</h6>
                                    {card.badge && <span className="dash-kpi-badge">{card.badge}</span>}
                                    {card.sub && <p className="dash-kpi-sub">{card.sub}</p>}
                                </div>
                                <div
                                    className={`w-40-px h-40-px ${card.iconBg} rounded-circle d-flex justify-content-center align-items-center`}
                                >
                                    <Icon icon={card.icon} className="text-white text-2xl mb-0" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default AnalyticCard;
